import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';


class ChangePassword extends Component {
    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            user: {
                currentPwd: "",
                newPwd: "",
                confirmationPwd: ""
            },
            formError: undefined
        }
    }

    handleChange(e) {
        let change = this.state.user;
        change[e.target.name] = e.target.value
        this.setState({ "user": change })
    }

    save(e) {
        e.preventDefault();
        if (this.state.user.currentPwd.trim() === "" || this.state.user.newPwd.trim() === "" || this.state.user.confirmationPwd.trim() === "") {
            this.setState({ formError: "Preencha todos os campos obrigatórios antes de prosseguir." })
        } else if (this.state.user.newPwd.trim() !== this.state.user.confirmationPwd.trim()) {
            this.setState({ formError: "A confirmação de senha não confere." })
        } else {

            this.setState({ isLoading: true });
            const _params = {
                "usuario": {
                    "senhaAtual": this.state.user.currentPwd,
                    "novaSenha": this.state.user.newPwd
                }
            }

            const _service = axios.post(this.Configurations.apiBasePath + `/usuario/alterar-senha`, _params);

            _service.then(res => {
                this.setState({
                    formError: undefined, user: {
                        currentPwd: "",
                        newPwd: "",
                        confirmationPwd: ""
                    },
                    isLoading: false
                }, () => {
                    alert('Senha alterada com sucesso');
                });

            }).catch(err => {
                this.setState({ formError: "A senha atual não confere.", isLoading: false });
            });
        }
    }


    render() {
        return (
            <div className="change-password">
                <div className="row">
                    <div className="col-12">
                        <h2 className="title-1">Alterar minha senha</h2>
                    </div>
                    <div className="col-6 colspan-3">
                        <div className="card rounded mt-4">
                            <form noValidate>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="txtCurrentPassword">Senha atual:</label>
                                                <input className="form-control" name="currentPwd" value={this.state.currentPwd} onChange={this.handleChange} type="password" id="txtCurrentPassword" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="txtNewPassword">Nova senha:</label>
                                                <input className="form-control" name="newPwd" value={this.state.newPwd} onChange={this.handleChange} type="password" id="txtNewPassword" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="txtConfirmationPassword">Confirmação de nova senha:</label>
                                                <input className="form-control" name="confirmationPwd" value={this.state.confirmationPwd} onChange={this.handleChange} type="password" id="txtConfirmationPassword" />
                                            </div>
                                        </div>
                                        {this.state.formError && (
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <span className="text-danger">{this.state.formError}</span>
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-12 text-right">
                                            <div className="form-group">
                                                <button className="btn btn-primary" onClick={this.save} disabled={this.state.isLoading}>
                                                    {this.state.isLoading && (<i className="fa fa-spinner fa-spin fa-fw mr-1"></i>)}
                                                    salvar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChangePassword;
